import { useGlobalMessageNotifications } from '@/hooks/messaging/useGlobalMessageNotifications';

// Non-visual — mount once near the top of the authenticated app so it
// runs for the whole session.
export const GlobalMessageNotifications = () => {
  useGlobalMessageNotifications();
  return null;
};
